import { Box } from '../../common/ui/Box';

export const PortPriceRow = ({ children }) => {
    return (
        <Box
            display="flex"
            padding={16}
            alignItems="center"
            marginBottom={24}
            borderRadius="8px"
            position="relative"
            height="240px"
            border="1px solid"
            borderColor="border.muted"
        >
            {children}
        </Box>
    );
};
